var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "print-invoice-container", style: _vm.containerStyle },
    [
      _c("div", { staticClass: "no-print control-bar" }, [
        _c(
          "div",
          { staticClass: "control-group" },
          [
            _c("span", { staticClass: "control-label" }, [_vm._v("Cỡ chữ:")]),
            _c("el-input-number", {
              staticStyle: { width: "100px" },
              attrs: { min: 7, max: 40, size: "small" },
              model: {
                value: _vm.fontSize,
                callback: function ($$v) {
                  _vm.fontSize = $$v
                },
                expression: "fontSize",
              },
            }),
            _c("span", { staticStyle: { "margin-left": "5px" } }, [
              _vm._v("px"),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "control-group" },
          [
            _c("span", { staticClass: "control-label" }, [_vm._v("Khổ giấy:")]),
            _c(
              "el-select",
              {
                staticStyle: { width: "80px" },
                attrs: { size: "small" },
                model: {
                  value: _vm.paperSize,
                  callback: function ($$v) {
                    _vm.paperSize = $$v
                  },
                  expression: "paperSize",
                },
              },
              [
                _c("el-option", { attrs: { label: "A4", value: "A4" } }),
                _c("el-option", { attrs: { label: "A5", value: "A5" } }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "control-group" },
          [
            _c("span", { staticClass: "control-label" }, [_vm._v("Hướng in:")]),
            _c(
              "el-select",
              {
                staticStyle: { width: "110px" },
                attrs: { size: "small" },
                model: {
                  value: _vm.orientation,
                  callback: function ($$v) {
                    _vm.orientation = $$v
                  },
                  expression: "orientation",
                },
              },
              [
                _c("el-option", {
                  attrs: { label: "Khổ dọc", value: "portrait" },
                }),
                _c("el-option", {
                  attrs: { label: "Khổ ngang", value: "landscape" },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "control-actions" },
          [
            _c(
              "el-tooltip",
              {
                attrs: {
                  effect: "dark",
                  content: "Cấu hình in",
                  placement: "bottom",
                },
              },
              [
                _c("el-button", {
                  attrs: {
                    type: "warning",
                    size: "medium",
                    circle: "",
                    icon: "el-icon-setting",
                  },
                  on: {
                    click: function ($event) {
                      _vm.showConfigDialog = true
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "el-tooltip",
              {
                attrs: {
                  effect: "dark",
                  content: "Xuất Excel",
                  placement: "bottom",
                },
              },
              [
                _c("el-button", {
                  attrs: {
                    type: "success",
                    size: "medium",
                    circle: "",
                    icon: "el-icon-download",
                  },
                  on: { click: _vm.exportExcel },
                }),
              ],
              1
            ),
            _c(
              "el-tooltip",
              {
                attrs: {
                  effect: "dark",
                  content: "In phiếu",
                  placement: "bottom",
                },
              },
              [
                _c("el-button", {
                  attrs: {
                    type: "primary",
                    size: "medium",
                    circle: "",
                    icon: "el-icon-printer",
                  },
                  on: { click: _vm.printReceipt },
                }),
              ],
              1
            ),
            _c(
              "el-tooltip",
              {
                attrs: { effect: "dark", content: "Đóng", placement: "bottom" },
              },
              [
                _c("el-button", {
                  attrs: {
                    type: "danger",
                    size: "medium",
                    circle: "",
                    icon: "el-icon-close",
                  },
                  on: { click: _vm.closeTab },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Cấu hình in phiếu thu",
            visible: _vm.showConfigDialog,
            width: "720px",
            "custom-class": "sk-dialog sk-dialog--md",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showConfigDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "sk-dialog__content",
              staticStyle: {
                display: "flex",
                gap: "16px",
                "align-items": "stretch",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "sk-panel",
                  staticStyle: { flex: "1", margin: "0" },
                },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c("div", { staticClass: "sk-panel-icon" }, [
                      _c("i", { staticClass: "el-icon-setting" }),
                    ]),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Tùy chọn in"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v("Hiển thị các khoản thu và thời gian"),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "sk-panel__body",
                      staticStyle: { padding: "16px 0 0" },
                    },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            "label-width": "210px",
                            "label-position": "left",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Khoản có đơn giá:" } },
                            [
                              _c("el-switch", {
                                model: {
                                  value: _vm.printConfig.printWithPrice,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.printConfig,
                                      "printWithPrice",
                                      $$v
                                    )
                                  },
                                  expression: "printConfig.printWithPrice",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "Khoản chưa có đơn giá:" } },
                            [
                              _c("el-switch", {
                                model: {
                                  value: _vm.printConfig.printWithoutPrice,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.printConfig,
                                      "printWithoutPrice",
                                      $$v
                                    )
                                  },
                                  expression: "printConfig.printWithoutPrice",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "Khoản tổng tiền = 0:" } },
                            [
                              _c("el-switch", {
                                model: {
                                  value: _vm.printConfig.printZeroAmount,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.printConfig,
                                      "printZeroAmount",
                                      $$v
                                    )
                                  },
                                  expression: "printConfig.printZeroAmount",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "Khoản số lượng = 0:" } },
                            [
                              _c("el-switch", {
                                model: {
                                  value: _vm.printConfig.printZeroQuantity,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.printConfig,
                                      "printZeroQuantity",
                                      $$v
                                    )
                                  },
                                  expression: "printConfig.printZeroQuantity",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "Hiển thị thời gian in:" } },
                            [
                              _c("el-switch", {
                                model: {
                                  value: _vm.printConfig.showTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.printConfig, "showTime", $$v)
                                  },
                                  expression: "printConfig.showTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "sk-panel",
                  staticStyle: { flex: "1", margin: "0" },
                },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c(
                      "div",
                      { staticClass: "sk-panel-icon sk-panel-icon--success" },
                      [_c("i", { staticClass: "el-icon-document" })]
                    ),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Hiển thị cột"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v("Ẩn/hiển thị cột dữ liệu trên bảng"),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "sk-panel__body",
                      staticStyle: { padding: "16px 0 0" },
                    },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            "label-width": "210px",
                            "label-position": "left",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Hiển thị cột ĐVT:" } },
                            [
                              _c("el-switch", {
                                model: {
                                  value: _vm.printConfig.showColUnit,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.printConfig,
                                      "showColUnit",
                                      $$v
                                    )
                                  },
                                  expression: "printConfig.showColUnit",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "Hiển thị cột Số lượng:" } },
                            [
                              _c("el-switch", {
                                model: {
                                  value: _vm.printConfig.showColQuantity,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.printConfig,
                                      "showColQuantity",
                                      $$v
                                    )
                                  },
                                  expression: "printConfig.showColQuantity",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "Hiển thị cột Đơn giá:" } },
                            [
                              _c("el-switch", {
                                model: {
                                  value: _vm.printConfig.showColPrice,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.printConfig,
                                      "showColPrice",
                                      $$v
                                    )
                                  },
                                  expression: "printConfig.showColPrice",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "Hiển thị cột Thuế:" } },
                            [
                              _c("el-switch", {
                                model: {
                                  value: _vm.printConfig.showColTax,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.printConfig, "showColTax", $$v)
                                  },
                                  expression: "printConfig.showColTax",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "Hiển thị cột Giảm giá:" } },
                            [
                              _c("el-switch", {
                                model: {
                                  value: _vm.printConfig.showColDiscount,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.printConfig,
                                      "showColDiscount",
                                      $$v
                                    )
                                  },
                                  expression: "printConfig.showColDiscount",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "Hiển thị cột Ghi chú:" } },
                            [
                              _c("el-switch", {
                                model: {
                                  value: _vm.printConfig.showColNote,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.printConfig,
                                      "showColNote",
                                      $$v
                                    )
                                  },
                                  expression: "printConfig.showColNote",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "sk-dialog__footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-cancel",
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.showConfigDialog = false
                    },
                  },
                },
                [_vm._v("Hủy")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn-save",
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.showConfigDialog = false
                    },
                  },
                },
                [_vm._v("Xác nhận")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "print-area",
          class: [_vm.paperSize.toLowerCase(), _vm.orientation],
        },
        _vm._l(_vm.filteredInvoices, function (invoiceInfo, invoiceIndex) {
          return _c(
            "div",
            {
              key: invoiceIndex,
              staticClass: "print-page",
              class: { "two-copies": _vm.copies === 2 },
            },
            _vm._l(_vm.copies, function (copyIndex) {
              return _c(
                "div",
                {
                  key: `${invoiceIndex}-${copyIndex}`,
                  staticClass: "invoice-page",
                },
                [
                  _c("div", { staticClass: "invoice-header" }, [
                    _c("div", { staticClass: "logo-box" }, [
                      _vm.schoolLogo
                        ? _c("img", {
                            attrs: { src: _vm.schoolLogo, alt: "Logo" },
                          })
                        : _c("div", { staticClass: "logo-placeholder" }, [
                            _c("span", [_vm._v("Logo Trường")]),
                          ]),
                    ]),
                    _c("div", { staticClass: "header-info" }, [
                      _c("h2", { staticClass: "company-name" }, [
                        _vm._v(_vm._s(_vm.companyName)),
                      ]),
                      _c("p", { staticClass: "company-address" }, [
                        _vm._v(_vm._s(_vm.companyAddress)),
                      ]),
                      _c("h1", { staticClass: "invoice-title" }, [
                        _vm._v("PHIẾU THU HỌC PHÍ"),
                      ]),
                      _c("p", { staticClass: "invoice-subtitle" }, [
                        _vm._v(
                          "Tháng " +
                            _vm._s(invoiceInfo.month || "...") +
                            "/" +
                            _vm._s(invoiceInfo.year || "...") +
                            " - Đợt " +
                            _vm._s(invoiceInfo.turn || "...")
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "qr-box" }, [
                      invoiceInfo.urlOnlinePayment
                        ? _c("img", {
                            attrs: {
                              src: invoiceInfo.urlOnlinePayment,
                              alt: "QR Code",
                            },
                          })
                        : _c("div", { staticClass: "logo-placeholder" }, [
                            _c("span", [_vm._v("Mã QR")]),
                          ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "invoice-meta" }, [
                    _c("div", { staticClass: "meta-left" }, [
                      _c("p", [
                        _c("strong", [_vm._v("Họ tên:")]),
                        _c("span", { staticClass: "meta-value" }, [
                          _vm._v(
                            _vm._s(invoiceInfo.fullName) +
                              " (" +
                              _vm._s(invoiceInfo.studentCode) +
                              ")"
                          ),
                        ]),
                      ]),
                      _c("p", [
                        _c("strong", [_vm._v("Lớp:")]),
                        _c("span", { staticClass: "meta-value" }, [
                          _vm._v(_vm._s(invoiceInfo.className || "")),
                        ]),
                      ]),
                      _c("p", [
                        _c("strong", [_vm._v("SĐT:")]),
                        _c("span", { staticClass: "meta-value" }, [
                          _vm._v(_vm._s(invoiceInfo.parentPhone || "")),
                        ]),
                      ]),
                    ]),
                    _vm._m(0, true),
                  ]),
                  _c("table", { staticClass: "invoice-table" }, [
                    _c("thead", [
                      _c("tr", [
                        _c(
                          "th",
                          {
                            staticStyle: { "text-align": "center" },
                            attrs: { width: "5%" },
                          },
                          [_vm._v("STT")]
                        ),
                        _c(
                          "th",
                          {
                            staticStyle: { "text-align": "center" },
                            attrs: { width: "23%" },
                          },
                          [_vm._v("Tên khoản thu")]
                        ),
                        _vm.printConfig.showColUnit
                          ? _c(
                              "th",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { width: "7%" },
                              },
                              [_vm._v("ĐVT")]
                            )
                          : _vm._e(),
                        _vm.printConfig.showColQuantity
                          ? _c(
                              "th",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { width: "5%" },
                              },
                              [_vm._v("SL")]
                            )
                          : _vm._e(),
                        _vm.printConfig.showColPrice
                          ? _c(
                              "th",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { width: "12%" },
                              },
                              [_vm._v("Đơn giá")]
                            )
                          : _vm._e(),
                        _vm.printConfig.showColTax
                          ? _c(
                              "th",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { width: "10%" },
                              },
                              [_vm._v("Thuế")]
                            )
                          : _vm._e(),
                        _vm.printConfig.showColDiscount
                          ? _c(
                              "th",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { width: "10%" },
                              },
                              [_vm._v("Giảm giá")]
                            )
                          : _vm._e(),
                        _c(
                          "th",
                          {
                            staticStyle: { "text-align": "center" },
                            attrs: { width: "13%" },
                          },
                          [_vm._v("Thành tiền")]
                        ),
                        _vm.printConfig.showColNote
                          ? _c(
                              "th",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { width: "25%" },
                              },
                              [_vm._v("Ghi chú")]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      _vm._l(
                        invoiceInfo.invoiceDetails,
                        function (item, index) {
                          return _c(
                            "tr",
                            {
                              key: index,
                              class: { "child-row": item._isChild },
                            },
                            [
                              _c(
                                "td",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      item._isChild
                                        ? ""
                                        : item._displayIndex || index + 1
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "td",
                                {
                                  staticStyle: { "text-align": "left" },
                                  style: item._isChild
                                    ? {
                                        "padding-left": `${
                                          (item._depth || 1) * 12
                                        }px`,
                                      }
                                    : {},
                                },
                                [
                                  item._isChild
                                    ? _c(
                                        "span",
                                        { staticClass: "child-indicator" },
                                        [_vm._v("- ")]
                                      )
                                    : _vm._e(),
                                  _vm._v(
                                    _vm._s(item.revenueName) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm.printConfig.showColUnit
                                ? _c(
                                    "td",
                                    { staticStyle: { "text-align": "center" } },
                                    [_vm._v(_vm._s(item.unit || ""))]
                                  )
                                : _vm._e(),
                              _vm.printConfig.showColQuantity
                                ? _c(
                                    "td",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatQuantity(item.quantity)
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.printConfig.showColPrice
                                ? _c(
                                    "td",
                                    { staticStyle: { "text-align": "right" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatCurrency")(item.price)
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.printConfig.showColTax
                                ? _c(
                                    "td",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item._isChild
                                            ? ""
                                            : _vm.formatTax(item.taxPercentage)
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.printConfig.showColDiscount
                                ? _c(
                                    "td",
                                    { staticStyle: { "text-align": "right" } },
                                    [
                                      item.discountNumber
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatCurrency")(
                                                  item.discountNumber
                                                )
                                              )
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "text-align": "right",
                                    "font-weight": "500",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatCurrency")(item.amount)
                                    )
                                  ),
                                ]
                              ),
                              _vm.printConfig.showColNote
                                ? _c(
                                    "td",
                                    { staticStyle: { "text-align": "left" } },
                                    [_vm._v(_vm._s(item.description || ""))]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]),
                  _c("table", { staticClass: "summary-table" }, [
                    _c("tbody", [
                      _c("tr", [
                        _c("td", { staticClass: "summary-label" }, [
                          _vm._v("Tổng cộng"),
                        ]),
                        _c(
                          "td",
                          { staticClass: "summary-value highlight-total" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatCurrency")(
                                  _vm.calcTotal(invoiceInfo)
                                )
                              )
                            ),
                          ]
                        ),
                      ]),
                      invoiceInfo.beforeMoney >= 0
                        ? _c("tr", [
                            _c("td", { staticClass: "summary-label" }, [
                              _vm._v("Tiền thừa phiếu thu trước"),
                            ]),
                            _c("td", { staticClass: "summary-value" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatCurrency")(
                                    invoiceInfo.beforeMoney || 0
                                  )
                                )
                              ),
                            ]),
                          ])
                        : _c("tr", [
                            _c("td", { staticClass: "summary-label" }, [
                              _vm._v("Tiền thiếu phiếu thu trước"),
                            ]),
                            _c("td", { staticClass: "summary-value" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatCurrency")(
                                    invoiceInfo.beforeMoney || 0
                                  )
                                )
                              ),
                            ]),
                          ]),
                      _c("tr", [
                        _c("td", { staticClass: "summary-label" }, [
                          _vm._v("Số tiền đã trả"),
                        ]),
                        _c("td", { staticClass: "summary-value" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatCurrency")(
                                invoiceInfo.collectedMoney || 0
                              )
                            )
                          ),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", { staticClass: "summary-label" }, [
                          _vm._v(
                            _vm._s(_vm.balanceLabel(invoiceInfo.afterMoney))
                          ),
                        ]),
                        _c(
                          "td",
                          {
                            staticClass: "summary-value",
                            class: {
                              "highlight-debt":
                                Number(invoiceInfo.afterMoney || 0) < 0,
                              "highlight-surplus":
                                Number(invoiceInfo.afterMoney || 0) > 0,
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm._f("formatCurrency")(
                                    Math.abs(
                                      Number(invoiceInfo.afterMoney || 0)
                                    )
                                  )
                                ) +
                                "\n              "
                            ),
                          ]
                        ),
                      ]),
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "words-amount",
                            attrs: { colspan: "2" },
                          },
                          [
                            _vm._v("\n                Bằng chữ: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.calcWords(invoiceInfo.afterMoney || 0)
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "footer-section",
                      staticStyle: {
                        "page-break-inside": "avoid",
                        "break-inside": "avoid",
                      },
                    },
                    [
                      _c("div", { staticClass: "invoice-notes" }, [
                        _vm._m(1, true),
                        _c("div", { staticClass: "bank-info" }, [
                          _c("p", [
                            _c("strong", [_vm._v("STK:")]),
                            _c("span", { staticClass: "bank-value" }, [
                              _vm._v(
                                _vm._s(
                                  invoiceInfo.bankAccount ||
                                    "......................"
                                )
                              ),
                            ]),
                          ]),
                          _c("p", [
                            _c("strong", [_vm._v("Chủ TK:")]),
                            _c("span", { staticClass: "bank-value" }, [
                              _vm._v(
                                _vm._s(
                                  invoiceInfo.bankOwner ||
                                    "......................"
                                )
                              ),
                            ]),
                          ]),
                          _c("p", [
                            _c("strong", [_vm._v("Ngân hàng:")]),
                            _c("span", { staticClass: "bank-value" }, [
                              _vm._v(
                                _vm._s(
                                  invoiceInfo.bankName ||
                                    "......................"
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "invoice-footer" }, [
                        _vm._m(2, true),
                        _c("div", { staticClass: "footer-right" }, [
                          _c("p", { staticClass: "signature-time" }, [
                            _vm._v(_vm._s(_vm.formattedPrintDate)),
                          ]),
                          _c("p", { staticClass: "signature-title" }, [
                            _vm._v("Người lập phiếu"),
                          ]),
                          _c("p", { staticClass: "signature-sub" }, [
                            _vm._v("(Ký, họ tên)"),
                          ]),
                          _c("div", { staticClass: "signature-name" }, [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  invoiceInfo.userPrint || "Trần Huy Hoàng"
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ]
              )
            }),
            0
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "meta-right" }, [
      _c("p", [
        _c("strong", [_vm._v("Mã:")]),
        _c("span", { staticClass: "meta-dots" }, [
          _vm._v(".................."),
        ]),
      ]),
      _c("p", [
        _c("strong", [_vm._v("Số:")]),
        _c("span", { staticClass: "meta-dots" }, [
          _vm._v(".................."),
        ]),
      ]),
      _c("p", [
        _c("strong", [_vm._v("Quyển:")]),
        _c("span", { staticClass: "meta-dots" }, [
          _vm._v(".................."),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("Ghi chú:")]),
      _vm._v(
        " PHHS vui lòng thanh toán tại văn phòng trường hoặc qua tài khoản ngân hàng của nhà trường trước ngày mùng 10 hàng tháng! Trân trọng cảm ơn."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "footer-left" }, [
      _c("p", { staticClass: "signature-title" }, [_vm._v("Người nộp tiền")]),
      _c("p", { staticClass: "signature-sub" }, [_vm._v("(Ký, họ tên)")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }